<template>
  <div v-if="mapImage" :class="$style.containerWrapper">
    <div :class="$style.container" :style="{height: `${calculatedHeight}px`}">
      <lv-image
        :class="$style.img"
        :style="{height: `${calculatedHeight}px`, width: `${calculatedWidth}px`}"
        auto-height
        :sources="[{url: mapImage?.url}]"
        :alt="mapImage?.alt"
      />
    </div>
  </div>
  <div v-else :class="$style.fallback">
    <img :src="fallbackImage" alt="Auchan" loading="lazy">
  </div>
</template>

<script>
  import { mapState } from 'pinia';
  import { useUserInterfaceStore } from '~~/common/stores/userInterface.js';
  import { LvImage } from '~~/common/components/loginet-vue-shop/index';
  import fallbackImage from '~~/shop/app/assets/images/stores/fallback.png';
  import defaultImage from '~~/common/assets/images/shop-entity-default.jpg';

  export default {
    name: 'AwStoreSvgMap',
    components: {
      LvImage,
    },
    props: {
      mapImage: {
        type: [Object, Boolean],
        required: true,
      },
    },
    data () {
      return {
        img: null,
        calculatedWidth: 0,
        fallbackImage,
      };
    },
    computed: {
      ...mapState(useUserInterfaceStore, {
        screenRange: state => state.mediaQueries,
      }),
      calculatedHeight () {
        return this.screenRange['tablet-min'] ? 520 : 320;
      },
    },
    watch: {
      calculatedHeight (newVal) {
        this.calculatedWidth = this.img?.width * (newVal / this.img?.height);
      },
    },
    mounted () {
      this.img = new Image();
      this.img.onload = () => {
        this.calculatedWidth = this.img?.width * (this.calculatedHeight / this.img?.height);
      };
      this.img.src = this.mapImage?.url || defaultImage;
    },
  };
</script>


<style module lang="scss" rel="stylesheet/scss">
.container {
  overflow: hidden;
  width: 100%;
  height: 320px;

  &Wrapper {
    position: relative;

    overflow: auto;
    width: 100%;
  }
}

.img {
  position: absolute;
  width: 100%;
  height: 320px;

  @include tablet(min) {
    height: 520px;
  }
}

.fallback {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 320px;
  border-radius: 24px;
  background-color: $color-background-3;
  @include tablet(min) {
    height: 520px;
  }
}
</style>
